// SPDX-License-Identifier: AGPL-3.0-or-later
import * as v from 'valibot';

const buildInfoSchema = v.object({
	PUBLIC_BUILD_SHA: v.nullish(v.string(), 'dev'),
	PUBLIC_BUILD_NUMBER: v.nullish(v.pipe(v.string(), v.transform(Number), v.number()), '0'),
	PUBLIC_BUILD_TIMESTAMP: v.nullish(v.pipe(v.string(), v.transform(Number), v.number()), '0'),
});
const runtimeConfigSchema = v.object({
	PUBLIC_RELEASE_CHANNEL: v.nullish(v.picklist(['stable', 'canary']), 'canary'),
	PUBLIC_BOOTSTRAP_API_ENDPOINT: v.nullish(v.string(), '/api'),
	PUBLIC_BOOTSTRAP_API_PUBLIC_ENDPOINT: v.nullish(v.string()),
});
const buildInfo = v.parse(buildInfoSchema, {
	PUBLIC_BUILD_SHA: import.meta.env.PUBLIC_BUILD_SHA,
	PUBLIC_BUILD_NUMBER: import.meta.env.PUBLIC_BUILD_NUMBER,
	PUBLIC_BUILD_TIMESTAMP: import.meta.env.PUBLIC_BUILD_TIMESTAMP,
});
const runtimeSource =
	typeof window !== 'undefined' &&
	(
		window as {
			__FLUXER_CONFIG__?: Record<string, string>;
		}
	).__FLUXER_CONFIG__
		? (
				window as unknown as {
					__FLUXER_CONFIG__: Record<string, string>;
				}
			).__FLUXER_CONFIG__
		: {
				PUBLIC_RELEASE_CHANNEL: import.meta.env.PUBLIC_RELEASE_CHANNEL,
				PUBLIC_BOOTSTRAP_API_ENDPOINT: import.meta.env.PUBLIC_BOOTSTRAP_API_ENDPOINT,
				PUBLIC_BOOTSTRAP_API_PUBLIC_ENDPOINT: import.meta.env.PUBLIC_BOOTSTRAP_API_PUBLIC_ENDPOINT,
			};
const runtime = v.parse(runtimeConfigSchema, runtimeSource);
export default {
	PUBLIC_BUILD_SHA: buildInfo.PUBLIC_BUILD_SHA,
	PUBLIC_BUILD_NUMBER: buildInfo.PUBLIC_BUILD_NUMBER,
	PUBLIC_BUILD_TIMESTAMP: buildInfo.PUBLIC_BUILD_TIMESTAMP,
	PUBLIC_RELEASE_CHANNEL: runtime.PUBLIC_RELEASE_CHANNEL,
	PUBLIC_BOOTSTRAP_API_ENDPOINT: runtime.PUBLIC_BOOTSTRAP_API_ENDPOINT,
	PUBLIC_BOOTSTRAP_API_PUBLIC_ENDPOINT:
		runtime.PUBLIC_BOOTSTRAP_API_PUBLIC_ENDPOINT ?? runtime.PUBLIC_BOOTSTRAP_API_ENDPOINT,
};
